import React, { createContext, useEffect, useState } from "react";
import { isAuthenticated } from "../commons/Auth/auth";
import axios from "axios";

const UserContext = createContext();

const UserContextProvider = ({ children }) => {
  const [loggedInUserObject, setLoggedInUserObject] = useState(null);

  const fetchUserAndUpdateMenu = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_URL}/employees/employee/${isAuthenticated()?.employeeId}`,
        { headers: { Authorization: "Bearer " + localStorage.getItem("token") } }
      );
      if (res.status === 200 || res.status === 304) {
        let data = res.data;
        setLoggedInUserObject({
          ...isAuthenticated(),
          permissions: data?.roleId?.permissions
        });
      } else {
        setLoggedInUserObject({ ...isAuthenticated(), permissions: undefined });
      }
    } catch (err) {
      console.error(err);
      // Route guards wait for this object; without it they would never render.
      setLoggedInUserObject({ ...isAuthenticated(), permissions: undefined });
    }
  };

  useEffect(() => {
    if (isAuthenticated().role == 1) {
      fetchUserAndUpdateMenu();
    } else {
      setLoggedInUserObject(isAuthenticated());
    }
    return () => {};
  }, []);

  return <UserContext.Provider value={loggedInUserObject}>{children}</UserContext.Provider>;
};

export { UserContext, UserContextProvider };
